var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManufacturers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ff8c08",
    stroke: "#ff8c08",
    strokeWidth: 0.00064,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff8c08f4ecce;}.cls-2{fill:#ff8c08;}.cls-3{fill:#ff8c08838bc5;}.cls-4{fill:#ff8c088f6c56;}")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 4,
    width: 6,
    x: 24,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    height: 14,
    width: 17,
    x: 6,
    y: 44
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "31 42 31 43 30 28 24 28 22 58 31 58 32 58 59 58 59 42 31 42"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "42 38 43 28 47 28 48 38"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "51 38 52 28 56 28 57 38"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "33 38 34 28 38 28 39 38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29,22V16.22a3,3,0,0,0,1-1.8A3.94,3.94,0,0,0,32,15a4,4,0,0,0,3.58-2.24,3,3,0,0,0,4.78.07,5,5,0,0,0,8.52,1.29,6,6,0,1,0,0-6.24,5,5,0,0,0-8.52,1.29,3,3,0,0,0-4.78.07A4,4,0,0,0,28,11c0,.06,0,.13,0,.19A2.89,2.89,0,0,0,27,11a3,3,0,0,0-2,5.22V22Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    height: 6,
    rx: 3,
    width: 30,
    x: 30,
    y: 38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    height: 2,
    width: 60,
    x: 2,
    y: 57
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "8 44 9 34 13 34 14 44"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 6,
    width: 4,
    x: 35,
    y: 48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 6,
    width: 4,
    x: 51,
    y: 48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 6,
    width: 4,
    x: 43,
    y: 48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2,
    width: 2,
    x: 9,
    y: 47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2,
    width: 2,
    x: 13,
    y: 47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2,
    width: 2,
    x: 17,
    y: 47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2,
    width: 2,
    x: 9,
    y: 51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2,
    width: 2,
    x: 13,
    y: 51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2,
    width: 2,
    x: 17,
    y: 51
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManufacturers);
export default __webpack_public_path__ + "static/media/manufacturers.436d562a0d5da6cf267535c03ab2e661.svg";
export { ForwardRef as ReactComponent };